import { gql } from '@apollo/client'

export const UPDATE_CAMPAIGN_CREATIONS = gql`
  mutation updateCampaignCreations(
    $id: ID!
    $creationContributionType: CreationContributionTypeEnum!
  ) {
    updateCampaignCreations(
      input: { id: $id, creationContributionType: $creationContributionType }
    ) {
      campaign {
        id
        creationContributionType
      }
      success
      errors
    }
  }
`
